import React, { useState, useEffect, useRef } from "react";
import { FaRegUserCircle, FaHome, FaPowerOff } from "react-icons/fa";
import { Link } from "react-router-dom";
import NetworkStatus from "../../../utils/networkStatus";
import { removeLoginAsNameFromLocalStorage } from "../../loginasuser/LoginAsUser";
import useMixpanelEventAction from "../../../config/mixpanel/useMixpanelEventAction";
import { useDispatch } from "react-redux";
import useProfile from "../../../hooks/useProfile";
import { userLogout } from "../../../redux/loginSlice";
import { headerData } from "../../../locales/en";
import { INVOICE } from "../../../route/paths";

const Header = () => {
  const dispatch = useDispatch();
  const [isAccountActive, setIsAccountActive] = useState(false);
  const hoverAccountRef = useRef(null);
  const { logoutMixpanelEvent } = useMixpanelEventAction();
  const { profileName } = useProfile();

  const toggle = () => {
    setIsAccountActive(!isAccountActive);
  };

  const handleLogout = () => {
    removeLoginAsNameFromLocalStorage();
    logoutMixpanelEvent(); // reset mixpanel
    dispatch(userLogout());
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        hoverAccountRef.current &&
        !hoverAccountRef.current.contains(event.target)
      ) {
        setIsAccountActive(false);
      }
    };

    // Add event listener to detect clicks outside the component
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Clean up the event listener when the component unmounts
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="header-account-section">
        <ul>
          <li>
            <button className="account-settings" onClick={toggle}>
              <FaRegUserCircle /> <span>{profileName}</span>
            </button>
          </li>
        </ul>
      </div>

      <div
        ref={hoverAccountRef}
        className={`hover-account-wrap headerGap ${isAccountActive ? "active-hover-account-wrap" : ""}`}
      >
        <ul>
          <li>
            <Link to={INVOICE}>
              <span>
                <FaHome />
              </span>
              {headerData.home}
            </Link>
          </li>
          <li>
            <Link onClick={handleLogout}>
              <span>
                <FaPowerOff />
              </span>
              {headerData.logout}
            </Link>
          </li>
        </ul>
      </div>

      <NetworkStatus />
    </>
  );
};

export default Header;
